// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2131355b","238":"89d49eec","453":"f8c658e1","455":"1ad7cab8"}[chunkId] + ".chunk.js";
};